// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-using-statement
require('../internals/define-well-known-symbol')('dispose');